import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import LondonImg from '../../../assets/images/london.png'
import styles from '../../Blog/Blog.module.scss'

const LondonDayTripChauffeur = () => {
  return (
    <div className={styles.blog}>
      <Helmet>
        <title>London Day Trip Chauffeur | Private Luxury Tours</title>
        <meta name="description" content="Explore London and surrounding attractions with a private day trip chauffeur. Luxury vehicles, professional drivers & customised sightseeing tours across the UK." />
      </Helmet>
      <div className={styles.blog__section}>
        <h1>London Day Trip Chauffeur</h1>
      </div>
      <div className={styles.blog__content}>
        <img
          src={LondonImg}
          alt="London Day Trip Chauffeur"
          title="London Day Trip Chauffeur"
          style={{ width: '100%', maxWidth: '800px', display: 'block', margin: '0 auto 1.5rem', borderRadius: '8px' }}
        />
        <p>
          Discover London in comfort and style with our Chauffeur-Driven London Tours. Whether you're exploring historic landmarks, indulging in a day of shopping, or entertaining clients, our chauffeur service for London tours ensures your journey is as memorable as the destination.
        </p>
        <p>
          Our <Link to="/contact">London day trip</Link> service is perfect for visitors wanting to see the best of the city and its surroundings. From Buckingham Palace and the Tower of London to the Cotswolds and Stonehenge, our professional chauffeurs will take you wherever you wish to go.
        </p>
        <p>
          Each tour is fully customisable to your interests and schedule. Want to visit Windsor Castle in the morning and explore Oxford in the afternoon? No problem. Our flexible service means you set the pace and the itinerary.
        </p>
        <p>
          Travel in the comfort of our luxury vehicles with a knowledgeable driver who can recommend the best spots, restaurants, and hidden gems. Whether you're a first-time visitor or a London local looking for a special day out, our day trip chauffeur service delivers an unforgettable experience.
        </p>
        <p>
          Plan your perfect day trip today and explore London and beyond in luxury and comfort.
        </p>
      </div>
    </div>
  )
}
export default LondonDayTripChauffeur
